import * as React from 'react'
import { useUserDocuments } from '@features/userDocuments'
import { Button } from '@shared/components/button'
import { SignFormCard } from '@shared/components/forms/sign/components/card'
import { FormikProvider } from 'formik'

import { useSignForm } from '../../..'

import { IStateProps } from './model'

import styles from './styles.module.scss'

const UNIFIED_PERSONALIZED_CONSENT = 'UNIFIED_PERSONALIZED_CONSENT'

export const View = ({ formik }: IStateProps) => {
	const { getPdfDataUri } = useUserDocuments()!
	const { toggleSpoiler } = useSignForm()

	const consentDataUri = getPdfDataUri(UNIFIED_PERSONALIZED_CONSENT)

	return (
		<FormikProvider value={formik}>
			<SignFormCard onToggleSpoiler={toggleSpoiler}>
				<form onSubmit={formik.handleSubmit}>
					Нажимая на кнопку «Далее», я даю своё{' '}
					<a
						target='_blank'
						rel='noopener noreferrer nofollow'
						href={consentDataUri}
						className={styles.link}
					>
						Согласие на обработку информации
					</a>{' '}
					и подтверждаю, что ознакомился и согласен с{' '}
					<a
						href='https://storage.yandexcloud.net/creditclub-frontend/static/docs/%D0%A4%D0%BE%D1%80%D0%BC%D0%B0%20%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8/14.12.2021/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5_%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5_%D1%81%D1%82%D0%B0%D1%82%D0%B8%D1%87%D0%BD%D0%BE%D0%B5.pdf'
						rel='noopener noreferrer nofollow'
						className={styles.link}
						target='_blank'
					>
						Пользовательским соглашением
					</a>
					.
					<Button
						type='submit'
						className={styles.submitButton}
						disabled={
							!Object.keys(formik.values).length ||
							!Object.values(formik.values).every(Boolean) ||
							formik.isSubmitting
						}
					>
						Далее
					</Button>
				</form>
			</SignFormCard>
		</FormikProvider>
	)
}
